export const initialState = {
    is_loading_jobs: true,
    jobs: [],
    jobs_list_search_text: "",
    selected_job: null,
    is_get_archive_job: false
}